// extracted by mini-css-extract-plugin
export default {"root":"SharingOnboarding__root--1KK5l","tabDesign":"SharingOnboarding__tabDesign--2wz0a","animated":"SharingOnboarding__animated--1vuc5"};